import { useMatches } from "@/lib/router";
import { useMemo } from "react";

export type RouteHandle = {
  hideIntercom?: boolean;
};

const useRouteHandle = (): RouteHandle => {
  const matches = useMatches();

  // Merged parent -> child, so the deepest matched route wins
  return useMemo(
    () =>
      matches.reduce<RouteHandle>(
        (merged, match) => Object.assign(merged, match.handle as RouteHandle),
        {},
      ),
    [matches],
  );
};

export default useRouteHandle;
